import { render, staticRenderFns } from "./TheFormCoupons.vue?vue&type=template&id=4c07ed11&scoped=true&"
import script from "./TheFormCoupons.vue?vue&type=script&lang=ts&"
export * from "./TheFormCoupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07ed11",
  null
  
)

export default component.exports